export const transformCache = (cache, transformGet, transformSet) => {
    const transform = (value, transformer) => {
        if (value === undefined) {
            return undefined;
        }
        return transformer(value);
    };
    const lookup = (key) => {
        if (cache.operation === 'sync') {
            return transform(cache.lookup(key), transformGet);
        }
        return cache.lookup(key).then((v) => transform(v, transformGet));
    };
    const save = (key, value) => {
        return cache.save(key, transformSet(value));
    };
    const transformedCache = {
        lookup,
        save,
    };
    Object.setPrototypeOf(transformedCache, cache);
    return transformedCache;
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=cache.js.map